export default "__VITE_ASSET__BkX7lo4u__"